<template>
  <div class="container-fluid" :class="{ 'mt-3': isMobile() }">
    <label
      :style="[
        !isMobile()
          ? { margin: '14px 28px 12px', 'font-size': '12px' }
          : { margin: '14px 0' },
      ]"
      class="required"
    >
      {{ $t("message.deliveryAddress") }}
    </label>
    <div class="order-type-enter-address" style="margin-bottom: 18px">
      <div class="input-icon-container" v-if="!isMobile()">
        <!-- <img src="@/assets/icons/icon-location.svg" /> -->
      </div>
      
        <vue-google-autocomplete
          v-model="address"
          id="deliveryAutocomplete"
          ref="autocompleteAddress"
          @keypress.enter="$event.preventDefault()"
          :enable-geolocation="true"
          @placechanged="handleAutocompletePlaceChange"
          @change="addressChanged"
          country="au"
          :disabled="disableAutocomplete"
          :placeholder="$t('message.addDeliveryAddress')"
          :class="{
            'order-type-address-input': !isMobile(),
            'form-control': isMobile(),
          }"
          style="googleInputStyles"
        />
     

      <div class="order-type-address-error" v-if="showErrorMessage">
        {{ $t("message.sorryWeCannotDeliverToThisAddress") }}
      </div>
      <div
        :style="[
          !isMobile()
            ? { margin: '14px 28px 12px', 'font-size': '12px' }
            : { margin: '14px 0' },
        ]"
      >
        {{ $t("message.additionalDetails") }}
      </div>
      <div class="order-type-enter-address">
        <div v-if="!isMobile()" class="input-icon-container">
          <!-- <img src="@/assets/icons/icon-location.svg" /> -->
        </div>
        <input
          type="text"
          autocomplete="address-line2"
          v-model="optionalAddress"
          :placeholder="$t('message.optionalUnitNumberBuildingNameEtc')"
          :class="{
            'order-type-address-input': !isMobile(),
            'form-control': isMobile(),
          }"
        />
      </div>
      <div class="pickup-button-container" v-if="showErrorMessage && storeSupportsPickup">
        <button
          type="button"
          class="btn btn-primary btn-lg btn-block d-flex justify-content-center align-items-center"
          :style="desktopStyles.btn"
          @click="pickUpInstead"
        >
          {{ $t("message.pickUpYourOrderInstead") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import shared from "../../../sharedscripts/shop/ordertype/EnterDeliveryAddress";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import { getCurrentDate } from "../../../api/helpers/datetimeHelper";

export default {
  name: "ChooseOrderType",
  components: {
    VueGoogleAutocomplete,
  },
  props: {
    storeSupportsPickup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      disableAutocomplete: false,
      optionalAddress: "",
      location: null,
      address: "",
      validateAddressDebounce: null,
      currentPlace: "",
    };
  },

  async mounted() {
    if (this.deliveryAddress.address) {
      this.address = this.deliveryAddress.address;
      const now = new getCurrentDate(
        this.currentStoreDoc.TimezoneIanaFormat
      ).toJSDate();
      await this.applyDeliveryAddress({
        address: this.deliveryAddress,
        scheduledTime: now.toISOString(),
        isUpdateDeliverAddress: true,
      });
      this.$emit("set-delivery-address", this.deliveryAddress);
    }
  },
  computed: {
    ...mapGetters(["desktopStyles", "currentStoreDoc"]),
    ...shared.computed,
    googleInputStyles() {
      return this.isOutOfService ? { color: "#E76E54" } : null;
    },

    isOutOfService() {
      return !this.getDeliveryIsLoading && this.addressOutOfService;
    },
    showErrorMessage() {
      return this.isOutOfService;
    },
  },
  methods: {
    ...shared.methods,
    async handleAutocompletePlaceChange(location, placeResultData) {
      await this.handleAddressUpdate(placeResultData);
    },
    async handleAddressUpdate(placeResultData) {
      this.currentPlace = this.$refs.autocompleteAddress.$el.value;

      this.location = {
        ...placeResultData,
        address: this.currentPlace,
      };
      await this.updateAddress();
      this.$emit("set-delivery-address", this.toModel());
    },
    pickUpInstead() {
      orderTypeHelper.setOrderTypePickup();
      this.$emit("pickup-instead");
    },
    addressChanged(place) {
      if (place !== this.currentPlace) {
        this.$emit("set-delivery-address", null);
      }
    },
  },
  watch: {
    isOutOfService(newValue) {
      this.$emit("delivery-address-enable", newValue);
    },
  },
};
</script>
